import {
  QuickAction,
  QuickActionsProvider,
  QuickActionsProviderContext,
  QuickActionsProviderRegistry,
} from './quick-actions-types';

// Default implementation of the quick actions provider registry
export class DefaultQuickActionsProviderRegistry implements QuickActionsProviderRegistry {
  private providers: Map<string, QuickActionsProvider> = new Map();

  register(provider: QuickActionsProvider): void {
    this.providers.set(provider.id, provider);
  }

  unregister(providerId: string): void {
    this.providers.delete(providerId);
  }

  getProviders(): QuickActionsProvider[] {
    return Array.from(this.providers.values()).sort((a, b) => b.priority - a.priority);
  }

  getActiveProviders(context: QuickActionsProviderContext): QuickActionsProvider[] {
    return this.getProviders().filter((provider) => {
      if (provider.isActive) {
        return provider.isActive(context);
      }
      return true; // Default to active if no isActive method
    });
  }

  getActions(context: QuickActionsProviderContext): QuickAction[] {
    const activeProviders = this.getActiveProviders(context);
    const allActions: QuickAction[] = [];

    for (const provider of activeProviders) {
      try {
        const actions = provider.getActions(context);
        allActions.push(...actions);
      } catch (error) {
        console.error(`Error getting actions from provider ${provider.id}:`, error);
      }
    }

    // Sort actions by priority (higher priority first)
    return allActions.sort((a, b) => (b.priority || 0) - (a.priority || 0));
  }
}

// Global registry instance
export const quickActionsProviderRegistry = new DefaultQuickActionsProviderRegistry();
